import { forwardRef, type ButtonHTMLAttributes } from "react";
import { cn } from "@/lib/utils";

interface AppBarButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    /** Accessible name, also shown as the tooltip. */
    label: string;
    /** Toggle buttons (My Day): exposes aria-pressed and the "on" background. */
    pressed?: boolean;
}

/**
 * A 36×36 icon button for the top bar. Colours follow the top-bar style
 * (Accent / Light / Dark) via the .mail-appbar-btn rules in styles/globals.css.
 */
export const AppBarButton = forwardRef<HTMLButtonElement, AppBarButtonProps>(
    ({ label, pressed, className, children, type, ...props }, ref) => (
        <button
            ref={ref}
            type={type ?? "button"}
            aria-label={label}
            title={label}
            aria-pressed={pressed}
            className={cn(
                "mail-appbar-btn relative inline-flex h-9 w-9 shrink-0 items-center justify-center rounded transition-colors",
                className
            )}
            {...props}
        >
            {children}
        </button>
    )
);
AppBarButton.displayName = "AppBarButton";
